module.exports = __webpack_public_path__ + "static/img/bg-id.4b8b51ca.webp";